module.exports = __webpack_public_path__ + "static/img/12012D_11_12_R_20190811_fit.fbcbaed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12012D_11_12_R_20190811_fit.png
// module id = vi7p
// module chunks = 0